// fix for safari fullscreen vimeo, site title and menu and things like that would just not disappear when entering fullscreen

var bindFullscreenChange = function () {
	var showMenuAndSiteTitle = function () {
		jQuery('.sitetitle, nav, .lay-navbar, .mobile-title, .lay-mobile-icons-wrap, #lay_canvas').css('display', '')
	}

	var hideMenuAndSiteTitle = function () {
		jQuery('.sitetitle, nav, .lay-navbar, .mobile-title, .lay-mobile-icons-wrap, #lay_canvas').css('display', 'none')
	}

	var onChange = function () {
		if (document.webkitFullscreenElement == null) {
			showMenuAndSiteTitle()
		} else {
			hideMenuAndSiteTitle()
		}
	}

	// handler for safari
	document.onwebkitfullscreenchange = function () {
		onChange()
	}
}

export { bindFullscreenChange }
